<template>
  <m-geo-box geo-option="state" title="State List">
    <m-geo-state-box :geoType="2"></m-geo-state-box>
  </m-geo-box>
</template>

<script>
  import MGeoStateBox from '@/components/geo/MGeoStateBox'
  import MGeoBox from '@/components/geo/MGeoBox'

  export default {
    components: {
      MGeoStateBox,
      MGeoBox
    },
    data () {
      return {
      }
    }
  }
</script>

<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// src/pages/order/GeoState.vue